import React from 'react';
import { AlertTriangle, CheckCircle, HelpCircle } from 'lucide-react';
import { RiskLevel } from '../types';
interface RiskLevelBadgeProps {
  level: RiskLevel;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function RiskLevelBadge({
  level,
  size = 'md',
  className = ''
}: RiskLevelBadgeProps) {
  const styles = {
    Low: {
      bg: 'bg-green-100',
      text: 'text-green-800',
      border: 'border-green-200',
      icon: CheckCircle,
      pulse: false
    },
    Medium: {
      bg: 'bg-yellow-100',
      text: 'text-yellow-800',
      border: 'border-yellow-200',
      icon: HelpCircle,
      pulse: false
    },
    High: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      border: 'border-red-200',
      icon: AlertTriangle,
      pulse: true
    }
  };
  const sizes = {
    sm: 'px-2 py-0.5 text-xs gap-1',
    md: 'px-3 py-1 text-sm gap-1.5',
    lg: 'px-4 py-1.5 text-base gap-2'
  };
  const config = styles[level];
  const Icon = config.icon;
  return <span className={`
        inline-flex items-center rounded-full font-medium border shadow-sm transition-all duration-300
        ${config.bg} ${config.text} ${config.border}
        ${sizes[size]}
        ${className}
        ${config.pulse ? 'animate-pulse-slow' : ''}
      `} data-id="element-251">
      <Icon className={`
          ${size === 'sm' ? 'w-3 h-3' : size === 'md' ? 'w-4 h-4' : 'w-5 h-5'}
          ${config.pulse ? 'animate-bounce-subtle' : ''}
        `} data-id="element-252" />
      {level} Risk
    </span>;
}